module.exports = __webpack_public_path__ + "static/media/infiniti-minus.a2cf7023.svg";